module.exports = __webpack_public_path__ + "img/lottery.0aaa38fa.png";